import { Content, Header } from "antd/es/layout/layout";
import React, { useEffect, useState } from "react";
import IMAGES from "../const/Image";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Button,
  Card,
  Dropdown,
  Layout,
  Menu,
  Modal,
  Space,
  notification,
} from "antd";
import API_URL from "../api/url";
import { Drawer, List, Avatar } from "antd";
import {
  needsNotificationPermission,
  requestNotificationPermission,
} from "../firebase";
import moment from "moment";
import {
  BellOutlined,
  DiffOutlined,
  LogoutOutlined,
  DownOutlined,
  UserOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import Sider from "antd/es/layout/Sider";
import {
  Outlet,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import {
  getMessaging,
  onMessage,
} from "firebase/messaging";
import staffRequest from "./UserManagement/StaffRequest";

import NotificationService from "../Services/NotificationService";
import { GetLoggedInUser, isSuperAdmin } from "../utils/utils";

const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const [hoveredItem, setHoveredItem] = useState(null);
  const [userName, setUserName] = useState("");
  const [visible, setVisible] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [readNotification, setReadNotification] = useState([]);
  const [showNotifPermissionModal, setShowNotifPermissionModal] =
    useState(false);
  const [notifPermissionLoading, setNotifPermissionLoading] = useState(false);

  const generateMenuList = () => {
    const user = GetLoggedInUser();
    if (!user) return [];
    console.log(user.permissions, "p");
    return [
      {
        key: "dashboard",
        icon: (
          <span className="icon-bg">
            <img src={IMAGES.HomeIcon} alt="" />
          </span>
        ),
        label: "Dashboard",
        onClick: () => {
          navigate("/dashboard");
        },
        // Dashboard is always visible to logged-in users
        visible: true,
      },
      {
        key: "Customers",
        icon: (
          <span className="icon-bg">
            <img src={IMAGES.Customers} alt="" />
          </span>
        ),
        label: "Customers",
        onClick: () => {
          navigate("/customers");
        },
        visible: user.permissions?.Customers >= 1 || isSuperAdmin(),
      },
      {
        key: "Categories",
        icon: (
          <span className="icon-bg">
            <img src={IMAGES.CategoriesIcon} alt="" />
          </span>
        ),
        label: "Categories",
        onClick: () => {
          navigate("/categories");
        },
        visible: user.permissions?.Categories >= 1 || isSuperAdmin(),
      },
      {
        key: "CustomServiceRequests",
        icon: (
          <span className="icon-bg">
            <img src={IMAGES.customeService} alt="" />
          </span>
        ),
        label: "Custom Service Requests",
        onClick: () => {
          navigate("/custom-service-request");
        },
        visible: user.permissions?.CustomServiceRequests >= 1 || isSuperAdmin(),
      },
      {
        key: "comment",
        icon: (
          <span className="icon-bg">
            <img src={IMAGES.TestimonialIcon} alt="" />
          </span>
        ),
        label: "Comments/Rating",
        onClick: () => {
          navigate("/comment-ratings");
        },
        // visible: user.permissions?.Reviews >= 1 || isSuperAdmin()
        visible: true,
      },
      {
        key: "Coupons",
        icon: (
          <span className="icon-bg">
            <img src={IMAGES.Coupons} alt="" />
          </span>
        ),
        label: "Coupons",
        onClick: () => {
          navigate("/coupons");
        },
        visible: user.permissions?.Coupons >= 1 || isSuperAdmin(), // This was correct
      },

      {
        key: "App Setting",
        icon: (
          <span className="icon-bg">
            <img src={IMAGES.SettingIcon} alt="" />
          </span>
        ),
        label: "App Setting",
        visible:
          user.permissions?.Banners >= 1 ||
          user.permissions?.Videos >= 1 ||
          isSuperAdmin(),
        children: [
          {
            key: "dashboard",
            icon: (
              <span className="icon-bg sub-icon">
                <img src={IMAGES.HomeIcon} alt="" />
              </span>
            ),
            label: <span style={{ fontSize: "15px" }}>App Dashboard</span>,
            visible: true,
            children: [
              {
                key: "Banners",
                label: <span style={{ fontSize: "14px" }}>Images/Banners</span>,
                icon: (
                  <span className="icon-bg list-icon">
                    <img src={IMAGES.ImageIcon} alt="" />
                  </span>
                ),
                onClick: () => {
                  navigate("/app-setting/dashboard/banner/list");
                },
                visible: user.permissions?.Banners >= 1 || isSuperAdmin(),
              },
              {
                key: "Videos",
                label: <span style={{ fontSize: "14px" }}>Videos</span>,
                icon: (
                  <span className="icon-bg list-icon">
                    <img src={IMAGES.VideoIcon} alt="" />
                  </span>
                ),
                onClick: () => {
                  navigate("/app-setting/dashboard/video");
                },
                visible: user.permissions?.Videos >= 1 || isSuperAdmin(),
              },
              {
                key: "AppVersion",
                label: <span style={{ fontSize: "14px" }}>App Version</span>,
                icon: (
                  <span className="icon-bg list-icon">
                    <img src={IMAGES.AppVersionIcon} alt="App Version" />
                  </span>
                ),
                onClick: () => {
                  navigate("/app-setting/dashboard/app-version");
                },
                visible: isSuperAdmin(),
              },
            ].filter((item) => item.visible !== false),
          },
        ].filter((item) => item.visible !== false),
      },

      {
        key: "Salons",
        icon: (
          <span className="icon-bg">
            <img src={IMAGES.SalonIcon} alt="" />
          </span>
        ),
        label: "Salons",
        onClick: () => {
          navigate("/salons");
        },
        visible: user.permissions?.Salons >= 1 || isSuperAdmin(),
      },
      {
        key: "Appointments",
        icon: (
          <span className="icon-bg">
            <img src={IMAGES.AppoinmentIcon} alt="" />
          </span>
        ),
        label: "Appointments",
        onClick: () => {
          navigate("/appoinments");
        },
        visible: user.permissions?.Appointments >= 1 || isSuperAdmin(),
      },

      {
        key: "Website Management",
        icon: (
          <span className="icon-bg">
            <img src={IMAGES.UserManagementIcon} alt="" />
          </span>
        ),
        label: "Website Management",
        // Only show if user has Staff/Roles permission OR is super admin
        visible:
          user.permissions?.Users >= 1 ||
          user.permissions?.Roles >= 1 ||
          isSuperAdmin(),
        children: [
          {
            key: "website-banner",
            label: <span style={{ fontSize: "15px" }}>Website Banners</span>,
            icon: (
              <span className="icon-bg sub-icon">
                <img src={IMAGES.UserIcon} alt="" />
              </span>
            ),
            onClick: () => {
              navigate("/website-management/banner/list");
            },
            visible: user.permissions?.Users >= 1 || isSuperAdmin(),
          },
          {
            key: "website-services",
            label: <span style={{ fontSize: "15px" }}>Website Services</span>,
            icon: (
              <span className="icon-bg sub-icon">
                <img src={IMAGES.UserIcon} alt="" />
              </span>
            ),
            onClick: () => {
              navigate("/website-management/services/list");
            },
            visible: user.permissions?.Users >= 1 || isSuperAdmin(),
          },
          {
            key: "testimonials",
            label: <span style={{ fontSize: "15px" }}>Testimonials</span>,
            icon: (
              <span className="icon-bg sub-icon">
                <img src={IMAGES.UserIcon} alt="" />
              </span>
            ),
            onClick: () => {
              navigate("/website-management/testimonials/list");
            },
            visible: user.permissions?.Users >= 1 || isSuperAdmin(),
          },
          {
            key: "about-us",
            label: <span style={{ fontSize: "15px" }}>About Us</span>,
            icon: (
              <span className="icon-bg sub-icon">
                <img src={IMAGES.UserIcon} alt="" />
              </span>
            ),
            onClick: () => {
              navigate("/website-management/about/list");
            },
            visible: user.permissions?.Users >= 1 || isSuperAdmin(),
          },
          {
            key: "contact",
            label: <span style={{ fontSize: "15px" }}>Contact Details</span>,
            icon: (
              <span className="icon-bg sub-icon">
                <img src={IMAGES.UserIcon} alt="" />
              </span>
            ),
            onClick: () => {
              navigate("/website-management/contact/list");
            },
            visible: user.permissions?.Users >= 1 || isSuperAdmin(),
          },
          {
            key: "enquiry",
            label: <span style={{ fontSize: "15px" }}>Enquiry</span>,
            icon: (
              <span className="icon-bg sub-icon">
                <img src={IMAGES.AdminIcon} alt="" />
              </span>
            ),
            onClick: () => {
              navigate("/website-management/enquiry/list");
            },
            visible: user.permissions?.Roles >= 1 || isSuperAdmin(),
          },
        ].filter((item) => item.visible !== false),
      }, 

      {
        key: "User Management",
        icon: (
          <span className="icon-bg">
            <img src={IMAGES.UserManagementIcon} alt="" />
          </span>
        ),
        label: "User Management",
        // Only show if user has Staff/Roles permission OR is super admin
        visible:
          user.permissions?.Users >= 1 ||
          user.permissions?.Roles >= 1 ||
          isSuperAdmin(),
        children: [
          {
            key: "Users",
            label: <span style={{ fontSize: "15px" }}>Users</span>,
            icon: (
              <span className="icon-bg sub-icon">
                <img src={IMAGES.UserIcon} alt="" />
              </span>
            ),
            onClick: () => {
              navigate("/user-management/users");
            },
            visible: user.permissions?.Users >= 1 || isSuperAdmin(),
          },
          {
            key: "Roles",
            label: <span style={{ fontSize: "15px" }}>Roles</span>,
            icon: (
              <span className="icon-bg sub-icon">
                <img src={IMAGES.AdminIcon} alt="" />
              </span>
            ),
            onClick: () => {
              navigate("/user-management/role");
            },
            visible: user.permissions?.Roles >= 1 || isSuperAdmin(),
          },
        ].filter((item) => item.visible !== false),
      },

      {
        key: "settings",
        icon: (
          <span className="icon-bg">
            <img src={IMAGES.SettingIcon} alt="" />
          </span>
        ),
        label: "Settings",
        onClick: () => {
          navigate("/settings");
        },
        // Dashboard is always visible to logged-in users
        visible: true
      },

    ].filter((item) => item.visible !== false);
  };

  const [totalRecords, setTotalRecords] = useState(0);
  // const [menues,setMenues]=useState(menuList)
  const [menues, setMenues] = useState(generateMenuList());
  // const { id } = useParams();

  useEffect(() => {
    setMenues(generateMenuList());
  }, [localStorage.getItem("userProfile")]);

  const showDrawer = () => {
    setVisible(true);
  };

  const closeDrawer = () => {
    setVisible(false);
  };

  const handleMouseEnter = () => {
    setCollapsed(false);
  };

  const handleMouseLeave = () => {
    setCollapsed(true);
    setHoveredItem(null);
  };

  const handleLogout = async () => {
    let deviceToken = localStorage.getItem("device_token");
    console.log(deviceToken, "deviceToken");
    // try {
    //   // Clear Firebase messaging tokens
    //   const messaging = getMessaging();
    //   try {
    //     const currentToken = await getToken(messaging);
    //     if (currentToken) {
    //       await deleteToken(messaging);
    //       console.log('FCM token deleted successfully');
    //     }

    //   } catch (error) {
    //     console.error("Error deleting FCM token:", error);
    //   }
    // } catch (error) {
    //   console.error("Error getting messaging instance:", error);
    // }

    try {
      const response = await staffRequest.logoutStaff({ deviceToken });
      if (response.status === 200) {
        localStorage.clear();
        navigate("/");
      } else {
        notification.error({
          message: "Something went wrong",
        });
      }
    } catch (e) {
      notification.error({
        message: "Failed to logout",
      });
      console.error("API Error:", e);
    }

    // Clear local storage and state
    // localStorage.clear();
    // setUserName("");
    // navigate("/");
  };

  const items = [
    // {
    //   label: 'Profile',
    //   key: '1',
    //   icon: <UserOutlined />,
    // },
    {
      label: "Logout",
      key: "2",
      icon: <LogoutOutlined />,
      onClick: handleLogout,
    },
  ];

  const menuProps = {
    items,
  };

  useEffect(() => {
    const loginName = localStorage.getItem("login");
    const permission = localStorage.getItem("permission");
    // console.log("loginName", JSON.parse(permission));
    setUserName(loginName);
  }, []);

  // check if user has permission to access module

  const hasPermission = (moduleName, minPermissionLevel = 1) => {
    const user = GetLoggedInUser();
    if (isSuperAdmin()) return true;

    if (user && user[moduleName]) {
      return user[moduleName] >= minPermissionLevel;
    }
    return false;
  };

  const fetchNotificationList = () => {
    setLoading(true);
    NotificationService.notificationList()
      .then((response) => {
        const rawData = response?.data?.data?.notificationData || [];

        const unreadNotifications = rawData.filter(
          (notification) => notification.adminReadStatus === 0
        );
        setNotifications(rawData);
        // setFilteredCategories(rawData);
        setTotalRecords(unreadNotifications.length);
      })
      .catch((error) => {
        // message.error("Failed to fetch categories.");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    // Foreground Notifications
    let unsubscribe = () => {};
    try {
      const messagingInstance = getMessaging();
      unsubscribe = onMessage(messagingInstance, (payload) => {
        toast.success(
          `${payload?.notification?.title}\n${payload?.notification?.body}`,
          {
            autoClose: 5000,
            position: "top-right",
          }
        );
        const audio = new Audio("/notify.wav");
        audio.play().catch((e) => console.error("Audio play failed:", e));
        fetchNotificationList();
      });
    } catch (error) {
      console.warn("Foreground messaging unavailable:", error);
    }

    return () => unsubscribe();
  }, []);

  // Foreground Notifications
  // onMessage(messaging, (payload) => {
  //   toast.success(
  //     `🔔 ${payload?.notification.title}\n${payload.notification.body}`
  //   );
  //       var audio = new Audio("/notify.wav");
  //   audio.play();
  //   fetchNotificationList();

  //   // console.log("Foreground Notification Received:", payload);
  // });

  useEffect(() => {
    fetchNotificationList();
  }, []);

  // After login: ask for notification permission, then save FCM token
  useEffect(() => {
    const shouldPrompt =
      localStorage.getItem("prompt_notification_permission") === "1";

    if (!shouldPrompt) {
      // Returning session: if permission already granted but token missing, sync quietly
      if (needsNotificationPermission() && Notification.permission === "granted") {
        requestNotificationPermission();
      }
      return;
    }

    if (typeof Notification === "undefined") {
      localStorage.removeItem("prompt_notification_permission");
      return;
    }

    if (Notification.permission === "denied") {
      localStorage.removeItem("prompt_notification_permission");
      return;
    }

    if (
      Notification.permission === "granted" &&
      localStorage.getItem("fcm_token")
    ) {
      // Already set up — refresh token quietly
      localStorage.removeItem("prompt_notification_permission");
      requestNotificationPermission();
      return;
    }

    setShowNotifPermissionModal(true);
  }, []);

  const dismissNotificationPrompt = () => {
    localStorage.removeItem("prompt_notification_permission");
    setShowNotifPermissionModal(false);
  };

  const handleAllowNotifications = async () => {
    setNotifPermissionLoading(true);
    try {
      const result = await requestNotificationPermission();
      if (result.success) {
        notification.success({
          message: "Notifications enabled",
          description: "You will now receive push notifications.",
        });
        dismissNotificationPrompt();
      } else {
        notification.warning({
          message: "Notifications not enabled",
          description:
            result.reason ||
            "You can enable notifications later from browser settings.",
        });
        dismissNotificationPrompt();
      }
    } catch (error) {
      console.error(error);
      dismissNotificationPrompt();
    } finally {
      setNotifPermissionLoading(false);
    }
  };

  const notificationUpdate = async (id) => {
    setLoading(true);
    try {
      const res = await NotificationService.updateNotification(id);
      if (res) {
        fetchNotificationList();
        navigate(`/dashboard/notifications?id=${id}`);
        closeDrawer();
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  // Filter menu items based on permissions

  return (
    <>
      <Modal
        open={showNotifPermissionModal}
        title={
          <span>
            <BellOutlined style={{ marginRight: 8 }} />
            Enable notifications
          </span>
        }
        onCancel={dismissNotificationPrompt}
        footer={[
          <Button key="later" onClick={dismissNotificationPrompt}>
            Not now
          </Button>,
          <Button
            key="allow"
            type="primary"
            loading={notifPermissionLoading}
            onClick={handleAllowNotifications}
          >
            Allow
          </Button>,
        ]}
        centered
        maskClosable={false}
      >
        <p style={{ marginBottom: 0 }}>
          Allow notifications so you can receive important updates about
          salons, appointments, and service requests.
        </p>
      </Modal>
      <div className="dashboard-container">
        <Header className=" header-admin" style={{ padding: 0 }}>
          <div className=" bg-header">
            <img src={IMAGES.BMBLogo} className="BMBLogo" alt="" />
            <div className=" head-r-logo">
              <div className=" header-menu d-flex gap-3 align-items-center">
                <div className="notification">
                  <img
                    src={IMAGES.notification}
                    alt="notification"
                    onClick={showDrawer}
                  />

                  <span>{totalRecords}</span>
                </div>
                <div>
                  <Dropdown menu={menuProps}>
                    <Button>
                      <img src={IMAGES.UserIcon} className="profile" alt="" />

                      {userName ? userName : "Loading..."}
                      <DownOutlined />
                    </Button>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
          <Drawer
            title={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <span>Notifications</span>
                <Button
                  type="link"
                  style={{
                    fontSize: "14px",
                    color: "#1890ff",
                    padding: 0,
                    fontWeight: 700,
                  }}
                  // onClick={() => navigate("/dashboard/notifications")}
                  onClick={() => {
                    closeDrawer();
                    navigate("/dashboard/notifications");
                  }}
                >
                  View All
                </Button>
              </div>
            }
            placement="right"
            closable
            onClose={() => setVisible(false)}
            open={visible}
            width={400}
          >
            <List
              itemLayout="vertical"
              dataSource={notifications}
              loading={loading}
              renderItem={(item) => {
                if (!item.id) {
                  console.error("Notification item has missing ID ", item);
                }

                return (
                  <List.Item
                    onClick={() => {
                      notificationUpdate(item.id);
                    }}
                    style={{ cursor: "pointer", padding: "8px 0" }}
                    className="notification-item"
                  >
                    <List.Item.Meta
                      avatar={
                        <Avatar
                          src={item.profileImage || "/default-profile.png"}
                        />
                      }
                      title={
                        <strong
                          style={{
                            color:
                              item?.adminReadStatus === 1 ? "gray" : "black",
                          }}
                        >
                          {item.title}
                        </strong>
                      }
                      description={
                        <>
                          <p style={{ fontSize: "15px", marginBottom: "0px" }}>
                            {item.description}
                          </p>
                          <span
                            style={{
                              color: "#b5b5b5",
                              fontSize: "12px",
                              display: "block",
                            }}
                          >
                            {new Date(item.createdAt).toLocaleDateString()} |{" "}
                            {new Date(item.createdAt).toLocaleTimeString()}
                          </span>
                        </>
                      }
                    />
                  </List.Item>
                );
              }}
            />
          </Drawer>
        </Header>
        <Layout className="layout_css">
          <Sider
            trigger={null}
            collapsible={false}
            collapsed={collapsed}
            className={collapsed ? "layoutSiderHovered" : "layoutSider"}
            onMouseEnter={() => handleMouseEnter(null)}
            onMouseLeave={handleMouseLeave}
          >
            <Menu
              style={{
                display: "flex",
                gap: "0px",
                flexDirection: "column",
                paddingLeft: "0px",
                paddingRight: "0px",
                borderInlineEnd: "0px",
              }}
              theme="light"
              mode="inline"
              items={menues}
            />
          </Sider>
          <Layout className="dslr-web bmb-wrapper">
            <Content
              className="content-shado"
              style={{
                margin: "20px 20px",

                height: "80%",
                maxHeight: "85%",
                overflowY: "auto",
              }}
            >
              <Card>
                <Outlet />
              </Card>
            </Content>
          </Layout>
        </Layout>
      </div>
    </>
  );
};

export default MainLayout;
